/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import headphonesWomanAnimationData from 'assets/animations/headphonesWoman.js';
import Character_B from 'assets/Character B.png';
import ReactBodymovin from 'react-lottie';
import { useHeader } from 'services/useHeader';

const EmptySection = () => {
  const header = useHeader();
  const currentHeader = header[header.props.headerStyle];
  const { headerHeight } = currentHeader.props;

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
        padding: ${headerHeight + 20}px 20px 20px 20px;
        cursor: pointer;
        ${!window.dev() && 'pointer-events: none;'}
      `}
      onClick={() => {
        parent.setNewSectionWizard && parent.setNewSectionWizard(true);
      }}
    >
      {window.dev() ? (
        <div
          css={css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '55%',
            maxWidth: 640,
            height: '75%',
            maxHeight: 420,
            padding: 30,
            border: '2px dashed #0094ff',
            borderRadius: 50,
            boxShadow: '0 0 0 2px transparent',

            transition: 'all 0.2s',
            ':hover': {
              border: '2px dashed transparent',
              boxShadow:
                '0 5px 20px rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(0, 148, 255, 0.8)',
            },

            background: '#fff',
          })}
        >
          <img
            src={Character_B}
            css={css({
              height: '80%',
            })}
          />
        </div>
      ) : (
        <div
          css={css`
            width: 80%;
            height: 80%;
            background: url('${Character_B}') no-repeat;
            background-size: contain;
            background-position: center;
          `}
        />
      )}

      <div
        css={css`
          position: relative;
          top: 30px;
          text-align: center;
          color: #0094ff;
          font-weight: 300;
        `}
      >
        {window.dev()
          ? 'Welcome! Click here to create an interaction.'
          : 'No interactions in topic'}
      </div>
    </div>
  );
};

export default EmptySection;
